export const FAQ_ITEMS = [
    {
        q: "What is Aqualyx?",
        a: "Aqualyx is the original injectable fat reduction treatment — a non-surgical body contouring solution that helps dissolve localized fat deposits. Manufactured in Italy and on the market for over 15 years with more than 4 million vials sold across 65+ countries.",
    },
    {
        q: "Is Aqualyx available in New Zealand?",
        a: "Yes. The original Aqualyx is available exclusively through Aqualyx Certified Clinics across New Zealand, including Auckland, Wellington, Christchurch, Queenstown, Hamilton, Tauranga, Palmerston North and Dunedin.",
    },
    {
        q: "Is Aqualyx Medsafe registered?",
        a: "Aqualyx™ is a Class III medical device, Medsafe registered in New Zealand. Always consult your healthcare professional to determine if treatment is right for you.",
    },
    {
        q: "How many treatments are needed?",
        a: "Most patients see visible results within the first two treatments. A typical course involves 2–6 sessions spaced 4–6 weeks apart, depending on the treatment area and individual goals.",
    },
    {
        q: "Is there downtime?",
        a: "Aqualyx is a non-surgical treatment with minimal downtime. Most patients return to their daily routine immediately, with some localized swelling or tenderness that subsides within a few days.",
    },
    {
        q: "Does Aqualyx hurt?",
        a: "Aqualyx contains a built-in anaesthetic component, making the procedure tolerable. Discomfort during and after the treatment is typically mild and short-lived.",
    },
    {
        q: "Is Aqualyx safe?",
        a: "When administered by a trained, certified medical professional, Aqualyx has an excellent safety profile backed by 15+ years on the market. Aqualyx™ has risks and benefits — consult your healthcare professional.",
    },
    {
        q: "What areas can be treated?",
        a: "Common treatment areas include the double chin, abdomen, flanks (love handles), arms, inner thighs, knees, bra fat and back rolls. The Aqualyx Face Kit is specifically designed for double chin contouring.",
    },
    {
        q: "How long until results appear?",
        a: "Initial contouring is often visible within 3–4 weeks. Progressive refinement continues over several months as the body naturally metabolises the released fat cells.",
    },
    {
        q: "How long do results last?",
        a: "Once fat cells are destroyed, they do not regenerate. Results are long-lasting provided patients maintain a stable weight and healthy lifestyle.",
    },
    {
        q: "Is Aqualyx the same as Kybella or Belkyra?",
        a: "No. Aqualyx is the original European-developed deoxycholate-based fat dissolving treatment with a unique formulation. Kybella/Belkyra is a separate North American product. Aqualyx is the international standard with 15+ years of clinical experience.",
    },
    {
        q: "How do I find an Aqualyx Certified Clinic?",
        a: "Use our Clinic Locator to find your nearest Aqualyx Certified Clinic. Only certified clinics offer the original Aqualyx in New Zealand.",
    },
    {
        q: "Who should not have Aqualyx?",
        a: "Aqualyx is not suitable for pregnant or breastfeeding women, patients with active skin infections in the treatment area, certain autoimmune or coagulation conditions, or those with known sensitivities to its components. A consultation with a certified provider will determine suitability.",
    },
];

export const BEFORE_AFTER = [
    {
        title: "Double Chin Contouring",
        area: "Submental · Double Chin",
        sessions: "3 sessions",
        src: "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/8unhl0rt_%40roberts_beauty_garden1%20%28after%202%20sessions%29.jpg",
        layout: "stacked",
    },
    {
        title: "Jawline Contouring",
        area: "Jaw & Lower Face",
        sessions: "3 sessions",
        src: "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/3stvd3wi_%40nursesarahaesthetics.jpg",
        layout: "sideBySide",
    },
    {
        title: "Abdominal Contouring",
        area: "Abdomen",
        sessions: "4 sessions",
        src: "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/s5s3hzx2_%40slimlineaesthetics5.jpg",
        layout: "stacked",
    },
    {
        title: "Culotte de Cheval",
        area: "Outer Thigh · Saddlebags",
        sessions: "3 sessions",
        src: "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/m3ry20zm_image.png",
        layout: "sideBySide",
    },
    {
        title: "Chest Fold Contouring",
        area: "Bra Line · Back & Side Rolls",
        sessions: "4 sessions",
        src: "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/o2m5jkkf_image.png",
        layout: "sideBySide",
    },
    {
        title: "Inner Knee Contouring",
        area: "Knees · Inner Knee Fat",
        sessions: "3 sessions",
        src: "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/45equakk_image.png",
        layout: "sideBySide",
    },
    {
        title: "Flank Contouring",
        area: "Flanks · Love Handles",
        sessions: "2 sessions",
        src: "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/s7s6uimo_image.png",
        layout: "stacked",
    },
];

export const BLOG_POSTS = [
    {
        slug: "aqualyx-vs-kybella",
        title: "Aqualyx vs Kybella: The Definitive Comparison",
        excerpt: "Both target stubborn fat — but Aqualyx is the original European formulation with 15+ years of clinical experience.",
        date: "2025-11-12",
        read: "6 min read",
        category: "Education",
        image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1200&q=80",
        body: [
            "Aqualyx and Kybella are both injectable fat dissolving treatments based on deoxycholic acid derivatives — but they are not identical. Aqualyx is the original European-developed treatment, manufactured in Italy and on the market since 2009, with more than 4 million vials administered across 65 countries.",
            "Kybella (known as Belkyra outside the US) is a North American product approved by the FDA in 2015, indicated specifically for submental fat. Aqualyx, by contrast, can be used to contour multiple body areas including the abdomen, flanks, inner thighs and arms — under the discretion of a trained medical professional.",
            "Choosing the original Aqualyx means choosing a treatment with deep European clinical heritage, traceable vial holograms ensuring authenticity, and an established Aqualyx Certified Clinic network across New Zealand. Aqualyx™ is a Class III medical device, Medsafe registered.",
        ],
    },
    {
        slug: "best-double-chin-treatment-nz",
        title: "The Best Double Chin Treatment in New Zealand",
        excerpt: "Non-surgical, precision-injected, and trusted globally — here's why Aqualyx leads the chin contouring conversation.",
        date: "2025-10-28",
        read: "5 min read",
        category: "Treatments",
        image: "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/ts3znd9n_10a%20%28post%29%20%281%29.png",
        body: [
            "The submental area — the soft pocket of fat beneath the chin — is notoriously resistant to diet and exercise. For decades, the only effective solutions were surgical. Today, the Aqualyx Face Kit offers a precise, non-surgical alternative that defines the jawline progressively over a small number of sessions.",
            "Aqualyx Face is more than an injection. It is a complete system that includes Seralyx — a serum containing soothing Physale compound, antioxidant Resveratrol, and a patented blend of hyaluronic acids — to support skin during and after the contouring process.",
            "Treatment is available exclusively at Aqualyx Certified Clinics in New Zealand. Find your nearest provider using our locator.",
        ],
    },
    {
        slug: "non-surgical-fat-reduction-new-zealand",
        title: "Non-Surgical Fat Reduction in New Zealand: A 2026 Guide",
        excerpt: "From submental to abdomen — where injectable fat reduction fits into modern body contouring.",
        date: "2025-10-14",
        read: "7 min read",
        category: "Guides",
        image: "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/yv0y95ys_14a%20%28grid%29.png",
        body: [
            "Body contouring has evolved well beyond invasive surgery. Modern, evidence-led non-surgical options now include injectable fat reduction with Aqualyx, radiofrequency tightening, cryolipolysis and high-intensity focused ultrasound.",
            "Injectable fat reduction with Aqualyx offers a uniquely precise approach: a trained medical professional can sculpt small or stubborn areas — a love handle, a knee, a chin — that other modalities struggle to address.",
            "Always consult a qualified healthcare professional and choose only an Aqualyx Certified Clinic to ensure you are receiving the original treatment.",
        ],
    },
    {
        slug: "does-aqualyx-work",
        title: "Does Aqualyx Work? The Science Behind Fat Dissolving Injections",
        excerpt: "A look at the deoxycholate mechanism and what clinical experience tells us.",
        date: "2025-09-30",
        read: "5 min read",
        category: "Science",
        image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=80",
        body: [
            "Aqualyx is based on the deoxycholate family of acids — naturally occurring compounds that disrupt fat cell membranes, allowing the body to metabolise and excrete fat through its normal lymphatic processes.",
            "Once fat cells are destroyed, they do not regenerate. This is why Aqualyx is considered a long-lasting solution when paired with a stable weight and healthy lifestyle.",
            "Always discuss expectations and suitability with a certified Aqualyx provider.",
        ],
    },
    {
        slug: "aqualyx-before-and-after",
        title: "Aqualyx Before and After: What to Realistically Expect",
        excerpt: "A look at typical contouring timelines, photography and the nuance of results.",
        date: "2025-09-15",
        read: "4 min read",
        category: "Results",
        image: "https://images.unsplash.com/photo-1595152452543-e5fc28ebc2b8?w=1200&q=80",
        body: [
            "Aqualyx is a progressive treatment. Visible contouring typically begins around 3–4 weeks after a session, with refinement continuing for several months. Most courses involve 2–6 sessions spaced 4–6 weeks apart.",
            "Photographic results vary by individual anatomy, treatment area and number of sessions. Always view results in the context of a qualified consultation.",
        ],
    },
    {
        slug: "jawline-contouring-nz",
        title: "Jawline Contouring in NZ: Defining Without Surgery",
        excerpt: "How the Aqualyx Face Kit redefines submental and lower-face contouring.",
        date: "2025-08-27",
        read: "5 min read",
        category: "Treatments",
        image: "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/aji1glci_8a%20post.png",
        body: [
            "A defined jawline is one of the most sought-after aesthetic outcomes. The Aqualyx Face Kit was designed specifically for the submental area and lower face, delivering progressive definition through a structured series of precision injections.",
            "Pair with a clinical skincare protocol for an even more refined finish.",
        ],
    },
    {
        slug: "fat-dissolving-injections-nz",
        title: "Fat Dissolving Injections NZ: The Original Choice",
        excerpt: "Why Aqualyx remains the international gold standard.",
        date: "2025-08-10",
        read: "4 min read",
        category: "Education",
        image: "https://customer-assets.emergentagent.com/job_aqualyx-nz/artifacts/td217x11_image.png",
        body: [
            "Not all fat dissolving injections are equal. Aqualyx is the original — manufactured in Italy, holographically traceable, and trusted by medical professionals in over 65 countries.",
            "When researching providers in New Zealand, always confirm they are part of the official Aqualyx Certified Clinic network.",
        ],
    },
    {
        slug: "aqualyx-treatment-cost-nz",
        title: "Aqualyx Treatment Cost in New Zealand",
        excerpt: "Understanding pricing structures across NZ certified clinics.",
        date: "2025-07-29",
        read: "4 min read",
        category: "Guides",
        image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&q=80",
        body: [
            "Aqualyx pricing in New Zealand varies by clinic, treatment area, and number of vials required per session. Most certified clinics offer transparent consultation processes that include a personalised treatment plan and total investment estimate.",
            "Always book directly with an Aqualyx Certified Clinic and ask for the digitally numbered hologram on each vial — proof of authentic Aqualyx product.",
        ],
    },
];
